<section class="row-freight" [ngClass]="{'item-list-selected': vehicle?.checked }" [ngStyle]="this.semaphoreState()">

  <div class="row container-date">
    <div class="col-lg-2 col-md-6">
      <span class="title-purple" title="{{(vehicle?.state && utils.isDefined(vehicle.state.active) || vehicle?.stateCompany && utils.isDefined(vehicle.stateCompany.active)) ?
          (stateVehicle ? 'Activo' : 'Inactivo'): '-'}}">
        Estado: {{(vehicle?.state && utils.isDefined(vehicle.state.active) || vehicle?.stateCompany &&
        utils.isDefined(vehicle.stateCompany.active)) ?
        (stateVehicle ? 'Activo' : 'Inactivo'): '-'}}
      </span>
    </div>
    <div class="col-lg-3 col-md-6">
      <span class="title-purple" title="{{vehicle?.vehicleType?.name ? vehicle.vehicleType.name : '-'}}">
        Tipo: {{vehicle?.vehicleType?.name ? vehicle.vehicleType.name : '-'}}
      </span>
    </div>
    <div class="col-lg-3 col-md-6">
      <span class="title-purple" title="{{vehicle?.validSOAT?.active ? 'Activo' : 'Inactivo'}}">
        SOAT: {{vehicle?.validSOAT?.active ? 'Activo' : 'Inactivo'}}
      </span>
    </div>
    <div class="col-lg-3 col-md-6">
      <span class="title-purple" title="{{vehicle?.validRTM?.active ? 'Activo' : 'Inactivo'}}">
        RTM: {{vehicle?.validRTM?.active ? 'Activo' : 'Inactivo'}}
      </span>
    </div>
  </div>

  <div class="row container-data">
    <div class="col-lg-2 col-md-6">
      <div class="label">
        Placa
      </div>
      <div class="text-bold label-field">
        <span title="{{vehicle.id}}">
          {{vehicle.id}}
        </span>
      </div>
    </div>
    <div class="col-lg-3 col-md-6">
      <div class="label">
        Propietario
      </div>
      <div class="text-bold label-field">
        <div
          title="{{utils.isDefined(vehicle.owner) && utils.isDefined(vehicle.owner.name) ? vehicle.owner.name : '-'}}">
          {{utils.isDefined(vehicle.owner) && utils.isDefined(vehicle.owner.name) ? vehicle.owner.name : '-'}}
        </div>
        <div
          title="{{utils.isDefined(vehicle.owner) && utils.isDefined(vehicle.owner.document) ? vehicle.owner.document : '-'}}">
          {{utils.isDefined(vehicle.owner) && utils.isDefined(vehicle.owner.document) ? vehicle.owner.document : '-'}}
        </div>
      </div>
    </div>
    <div class="col-lg-3 col-md-6">
      <div class="label">
        Conductor
      </div>
      <div class="text-bold label-field">
        <div title="{{vehicle?.driver?.name ? vehicle.driver.name : '-'}}">
          {{vehicle?.driver?.name ? vehicle.driver.name : '-'}}
        </div>
        <div title="{{vehicle?.driver?.document ? vehicle.driver.document : '-'}}">
          {{vehicle?.driver?.document ? vehicle.driver.document : '-'}}
        </div>
      </div>
    </div>
    <div class="col-lg-3 col-md-6" *ngIf="vehicle?.administrator?.document">
      <div class="label">
        Administrador
      </div>
      <div class="text-bold label-field">
        <div title="{{vehicle?.administrator?.name}}">
          {{vehicle?.administrator?.name}}
        </div>
        <div title="{{vehicle?.administrator?.document}}">
          {{vehicle?.administrator?.document}}
        </div>
      </div>
    </div>
  </div>

  <div class="vehicle__alert"
    *ngIf="utils.isDefined(vehicle) && utils.isDefined(vehicle.state) && utils.isDefined(vehicle.state.active) && !vehicle.state.active && utils.isDefined(vehicle.state.description)">
    <div class="alert alert-warning">
      <span class="title-purple" title="{{vehicle.state.description | StateUser}}">
        <i class="fas fa-exclamation-triangle"></i>
        {{vehicle.state.description | StateUser}}
      </span>
    </div>
  </div>
  <figure class="icon-arrow-container" (click)="openDetail()">
    <img src="/assets/svg/icons/icon-arrow-right-short.png" alt="">
  </figure>
</section>